var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAnalyst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.93571 23C8.40093 23 7.96777 22.574 7.96777 22.0481V11.199C7.96777 10.673 8.40093 10.2471 8.93571 10.2471C9.4705 10.2471 9.90365 10.673 9.90365 11.199V22.0481C9.90365 22.574 9.4705 23 8.93571 23Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0656 23.0009C14.5308 23.0009 14.0977 22.575 14.0977 22.049V12.404C14.0977 11.8781 14.5308 11.4521 15.0656 11.4521C15.6004 11.4521 16.0335 11.8781 16.0335 12.404V22.049C16.0335 22.575 15.6004 23.0009 15.0656 23.0009Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1955 23.0005C20.6607 23.0005 20.2275 22.5745 20.2275 22.0486V8.18431C20.2275 7.65839 20.6607 7.23242 21.1955 7.23242C21.7303 7.23242 22.1634 7.65839 22.1634 8.18431V22.0486C22.1634 22.5745 21.7303 23.0005 21.1955 23.0005Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8068 23.0005C2.27202 23.0005 1.83887 22.5745 1.83887 22.0486V15.4187C1.83887 14.8928 2.27202 14.4668 2.8068 14.4668C3.34159 14.4668 3.77474 14.8928 3.77474 15.4187V22.0486C3.77474 22.5745 3.34159 23.0005 2.8068 23.0005Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.967352 11.5491C0.660032 11.5491 0.357551 11.4063 0.171224 11.1398C-0.133677 10.7067 -0.0223638 10.1141 0.415628 9.81428L8.38417 4.38852C8.62615 4.22432 8.93105 4.17672 9.21418 4.26001L14.8693 5.9282L22.4435 0.197831C22.8669 -0.123432 23.4743 -0.0449008 23.801 0.37155C24.1277 0.788001 24.0478 1.38531 23.6243 1.70657L15.6558 7.73441C15.409 7.92002 15.0871 7.97952 14.7871 7.89147L9.10286 6.21614L1.51908 11.3778C1.34969 11.492 1.15852 11.5467 0.969772 11.5467L0.967352 11.5491Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnalyst);
export default __webpack_public_path__ + "static/media/icon_analyst.30dd477e53ab8b313a16c5861d991874.svg";
export { ForwardRef as ReactComponent };